export default __webpack_public_path__ + "static/media/Cera_Scaglie_Fumo_120x120.e9197d57.jpg";